import { CerFormView } from "@form/cer-form-view";
import { CerFormViewSet } from "@form/cer-form-view-set";
import { CerFormRouteOptions } from "@form/cer-form-route-options";

export class CerFormViewFactoryComponent {

  public static formviewSetFromRouteOptions(routeOptions: CerFormRouteOptions): CerFormViewSet {
    var view = new CerFormView();
    view.paneTarget = routeOptions.navigation?.paneTarget;
    view.viewType = 'custom';
    view.title = routeOptions.navigation?.title ?? routeOptions.title;
    view.routeOptions = routeOptions;
    view.mandatory = (routeOptions.context.parentView == null);
    
    var viewSet = new CerFormViewSet();
    viewSet.routeOptions = routeOptions;
    viewSet.viewAdd(view);
    return viewSet;
  }
}